<template>
    <div class="UserProfileCircle aspect-square">
        <img
            v-if="displayImage"
            class="size-full rounded-full object-cover"
            loading="lazy"
            :src="displayImage"
            @error="handleImageError"
        />

        <CIcon v-else class="size-full" :class="{ 'text-white': isOpen }" name="account-circle" />
    </div>
</template>

<script setup lang="ts">
import type { UserProfile } from '#shared/types/User'
import CIcon from '@/components/ui/CIcon.vue'
import { useApplicationStore } from '@/stores/application'
import { computed, ref, watch } from 'vue'

const props = defineProps<{
    customProfile?: UserProfile
    isOpen?: boolean
}>()

const store = useApplicationStore()
const hasImageError = ref(false)

const userProfileImage = computed((): string | undefined => {
    if (props.customProfile?.id && props.customProfile.id === store.APPLICATION_USER_ID) {
        return store.userProfile?.profileImg || props.customProfile.profileImg
    }

    const profile = props.customProfile || store.userProfile
    return profile?.profileImg
})

const displayImage = computed((): string | undefined => {
    return hasImageError.value ? undefined : userProfileImage.value
})

watch(userProfileImage, () => {
    hasImageError.value = false
})

function handleImageError() {
    hasImageError.value = true
}
</script>
